export default __webpack_public_path__ + "static/media/vi.c25947a9.jpg";